// extracted by mini-css-extract-plugin
export default {"upperTextShieldRoot":"upperTextShieldRoot___W93pG","s":"s___jI3up","m":"m___bBEPD","l":"l___eN0RL","upperTextShieldImg":"upperTextShieldImg___L2ZzI"};